import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js/max';
import * as Flags from 'country-flag-icons/react/3x2';
import { MessengerPhoneValue } from './booking-validation';

const names = new Intl.DisplayNames(['en'], { type: 'region' });
const countries = getCountries().map(code => {
    const name = names.of(code) ?? code;
    const dialCode = `+${getCountryCallingCode(code)}`;
    return { code, name, dialCode, label: `${name} (${dialCode})` };
}).sort((left, right) => left.name.localeCompare(right.name));

type Country = typeof countries[number];
function countryTemplate(country: Country | null) {
    if (!country) return <span>Select country calling code</span>;
    const Flag = Flags[country.code as keyof typeof Flags];
    return <span className="flex align-items-center gap-2">
        {Flag && <Flag className="service-country-flag" aria-hidden="true" />}
        <span>{country.label}</span>
    </span>;
}

export function MessengerPhoneInput({ id, value, onChange, disabled, invalid, describedBy }: {
    id: string; value: MessengerPhoneValue; onChange: (value: MessengerPhoneValue) => void;
    disabled: boolean; invalid: boolean; describedBy?: string;
}) {
    return <div className="service-phone-inputs">
        <Dropdown inputId={`${id}-country`} aria-label="Country calling code" value={value.country ?? null}
            options={countries} optionLabel="label" optionValue="code" itemTemplate={countryTemplate}
            valueTemplate={countryTemplate} filter filterBy="label,code" resetFilterOnHide
            placeholder="Select country calling code" className={invalid ? 'w-full p-invalid' : 'w-full'}
            disabled={disabled} aria-invalid={invalid} aria-describedby={describedBy}
            onChange={event => onChange({ ...value, country: event.value as CountryCode })} />
        <InputText id={id} type="tel" inputMode="tel" autoComplete="tel-national"
            placeholder="Phone number" value={value.number} maxLength={40}
            className={invalid ? 'w-full p-invalid' : 'w-full'} aria-invalid={invalid}
            aria-describedby={describedBy} disabled={disabled}
            onChange={event => onChange({ ...value, number: event.target.value })} />
    </div>;
}
